module.exports = __webpack_public_path__ + "img/skirt_length.92e6eb5e.png";